import React from 'react';
import TextAndMedia from '../TextAndMedia';
import Container from 'components/Container';
import CertificatesGallery from '../CertificatesGallery';
import ContentCarousel from '../ContentCarousel';
import Gallery from '../Gallery';
import { ContentSection } from 'Pages/Main/cmsTypes';

interface GenericContentProps {
  content?: ContentSection[];
}

const GenericContent = ({ content }: GenericContentProps) => {
  if (!content || !Array.isArray(content)) {
    return null;
  }

  return (
    <div>
      {content.map((section) => {
        if (section.__component === 'content.carousel') {
          return (
            <Container key={section.id}>
              <ContentCarousel section={section} />
            </Container>
          );
        }

        if (section.__component === 'content.text-and-media') {
          return (
            <Container key={section.id}>
              <TextAndMedia section={section} />
            </Container>
          );
        }

        if (section.__component === 'content.certificates') {
          return (
            <Container key={section.id}>
              <CertificatesGallery section={section} />
            </Container>
          );
        }

        if (section.__component === 'content.gallery') {
          return (
            <Container key={section.id}>
              <Gallery section={section} />
            </Container>
          );
        }

        return null;
      })}
    </div>
  );
};

export default GenericContent;
